import z from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';

import { userInfoSchema } from './user.models';

export const GET_USER_TYPE = 'user/get-user';

export const getUser = defineQuery(GET_USER_TYPE, z.object({}), userInfoSchema);

export const GET_ADMIN_USER_TYPE = 'user/get-admin-user';

// Only super-admins exist today, so identity for the admin plane is just who signed in;
// access-right unification across both planes is a follow-up.
export const getAdminUser = defineQuery(
    GET_ADMIN_USER_TYPE,
    z.object({}),
    z.object({
        sub: z.string(),
        email: z.email(),
    }),
);
